const ModalHelper = ((bodyCls) => {
    let scrollTop
    return {
        afterOpen: function () {
            scrollTop = document.scrollingElement.scrollTop
            document.body.classList.add(bodyCls)
            document.body.style.top = -scrollTop + 'px'
        },
        beforeClose: function () {
            document.body.classList.remove(bodyCls)
            if (scrollTop) {
                document.scrollingElement.scrollTop = scrollTop
            }
        }
    }
})('dialog-open')

export const Modal = ModalHelper
